import {instance, onErrorFunction} from "../../config/axios-cnf";

export const apiGetAction = (callback, error) => {
    instance.get("/api/v1/action")
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}

export const apiPostAction = (data,callback, error) => {
    instance.post("/api/v1/action", data)
        .then(response => callback(response.data))
        .catch(err => error(onErrorFunction(err)))
}
